import GET_DASHBOARD_COUNT_ADMIN from "./getDashboardCountAdmin"
import GET_DASHBOARD_COUNT_USER from "./getDashboardCountUser"

export default {
  GET_DASHBOARD_COUNT_ADMIN,
  GET_DASHBOARD_COUNT_USER
}
